import type {
  UseAnalyticsSettingsParams,
  AnalyticsSettingsQueryKey,
} from './types';

export const getAnalyticsSettingsKey = (
  params: UseAnalyticsSettingsParams,
): AnalyticsSettingsQueryKey => ['groups', 'analyticsSettings', params];
